// src/pages/Login.js
import React, { useState } from 'react';
import { merchantLogin } from '../services/firebase';
import toast from 'react-hot-toast';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    if (!email || !password) { toast.error('Enter email and password'); return; }
    setLoading(true);
    try {
      await merchantLogin(email, password);
      toast.success('Welcome back! 🏪');
    } catch (e) {
      if (e.code === 'auth/user-not-found' || e.code === 'auth/wrong-password' || e.code === 'auth/invalid-credential') {
        toast.error('Invalid email or password');
      } else {
        toast.error('Login failed. Try again.');
      }
    } finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: '100vh', background: 'var(--black)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
      <div style={{ width: '100%', maxWidth: 400 }}>

        {/* Logo */}
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <div style={{ fontSize: 56, marginBottom: 12 }}>🏪</div>
          <div style={{ fontSize: 28, fontWeight: 900, color: 'var(--green)' }}>MyTownly</div>
          <div style={{ fontSize: 15, fontWeight: 600, color: 'var(--text)', marginTop: 2 }}>Merchant Dashboard</div>
          <div style={{ fontSize: 13, color: 'var(--gray)', marginTop: 6 }}>Manage your shop in Piler, AP</div>
        </div>

        {/* Login card */}
        <div className="card" style={{ padding: 28 }}>
          <div style={{ fontSize: 18, fontWeight: 800, marginBottom: 20 }}>Sign in to your shop</div>

          <div style={{ marginBottom: 14 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--gray)', marginBottom: 6, letterSpacing: 0.5 }}>EMAIL</div>
            <input type="email" placeholder="shop@example.com" value={email}
              onChange={e => setEmail(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleLogin()} />
          </div>

          <div style={{ marginBottom: 24 }}>
            <div style={{ fontSize: 11, fontWeight: 700, color: 'var(--gray)', marginBottom: 6, letterSpacing: 0.5 }}>PASSWORD</div>
            <input type="password" placeholder="••••••••" value={password}
              onChange={e => setPassword(e.target.value)}
              onKeyDown={e => e.key === 'Enter' && handleLogin()} />
          </div>

          <button className="btn btn-green" onClick={handleLogin} disabled={loading}>
            {loading ? <span className="spinner" /> : 'Sign In →'}
          </button>

          <div style={{ textAlign: 'center', marginTop: 16, fontSize: 12, color: 'var(--gray)', lineHeight: 1.6 }}>
            Don't have an account? Contact<br />
            <span style={{ color: 'var(--green)', fontWeight: 700 }}>MyTownly team to get set up</span>
          </div>
        </div>

        <div style={{ textAlign: 'center', marginTop: 24, fontSize: 11, color: 'var(--gray)' }}>
          MyTownly Merchant • Piler, AP
        </div>
      </div>
    </div>
  );
}
